import { LoadingOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import { Button, Flex } from '@revenuemarket/cds';
import { Colors } from '@revenuemarket/design';

const RemovalModalButton = styled(Button)`
  min-width: 60px;
  display: flex;
  justify-content: center;
`;

export const StepFooter = ({
  step,
  setStep,
  setChangeMap,
  onCancel,
  isLoading,
  defaultStep,
  onRemove,
}: {
  step: number;
  setStep: (step: number) => void;
  setChangeMap: (changeMap: Record<string, string>) => void;
  onCancel?: () => void;
  isLoading: boolean;
  defaultStep?: number;
  onRemove: () => void;
}) => {
  switch (step) {
    case 1:
      return (
        <Flex gap={5} justify="flex-end">
          <RemovalModalButton buttonType="weak" border onClick={onCancel}>
            닫기
          </RemovalModalButton>
          <RemovalModalButton
            disable={isLoading}
            icon={
              isLoading ? (
                <LoadingOutlined style={{ color: Colors.white, fontSize: 16 }} />
              ) : undefined
            }
            onClick={async () => {
              setStep(2);
            }}
          >
            다음
          </RemovalModalButton>
        </Flex>
      );
    case 2:
      return (
        <Flex gap={5} justify="flex-end">
          <RemovalModalButton buttonType="weak" border onClick={onCancel}>
            닫기
          </RemovalModalButton>
          {defaultStep !== 2 && (
            <RemovalModalButton
              onClick={() => {
                setStep(1);
                setChangeMap({});
              }}
            >
              이전
            </RemovalModalButton>
          )}
          <RemovalModalButton
            buttonType="primary"
            disable={isLoading}
            danger
            icon={
              isLoading ? (
                <LoadingOutlined style={{ color: Colors.white, fontSize: 16 }} />
              ) : undefined
            }
            onClick={async () => {
              onRemove();
            }}
          >
            삭제
          </RemovalModalButton>
        </Flex>
      );
  }
};
